module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Join_Form', {
		configure: function() {
			this.callParent('configure', arguments);
			this.registerOptions('', {
				autoRender: true,
				optionsBy: 'groupId', //any other value mean optionId (settings.id)
				totalContentAllowed: false,
				widgets: {
					totalApi: {
						widget: 'Api',
						method: 'site.totalPublished',
						cacheChannel: 'content'
					},
					joinOptions: {
						widget: 'List'
					},
					errors: {
						widget: 'List',
						tpl: {
							row: 'sitepage_join_form_error_row'
						},
						container: '#join-form-errors',
						autoRender: false
					},
					form: {
						widget: 'DomForm',
						validateOnFly: true,
						elements: {
							joinOptions: {
								womContainer: '@parent #joinOptions'
							}
						},
						handleWom: {
							formvalidate: {
								event: 'form_not_valid',
								widget: '@this',
								callback: function (infos) {
									var obj = {answer: {data: {}}};
									var s = obj.answer.data;

									infos.reverse().forEach(function (info) {
										if (info.result === false) {
											s[info.field] = [
												{message: info.message}
											];
											obj.answer.reason = info.message;
										}
									});

									this.onPrepareFailed(obj);
								}.bind(this)
							}
						}
					},

					prepareTransactionApi: {
						widget: 'Api',
						method: 'ubs.prepareTransaction',
						project: 'publisher'
					},
					billerOptionsForm: {
						widget: 'Widget',
						widgets: {
							optionsList: {
								widget: 'List',
								autoRender: true
							}
						},
						handleWom: {
							onListInDom: {
								event: 'addedToDom',
								widget: '#optionsList',
								callback: '@parent:_sendBillerForm'
							}
						},
						autoRender: false
					}
				},
				handleWom: {
					onSubmit: {
						widget: '#form',
						event: 'submit',
						callback: 'onSubmit'
					}
				}
			});
		},

		init: function() {
			this.siteId = fox.site.dl.getObjectValue('id');
			this.userData = {};
			this.api = null;

			this.registerOptions('#form', {
				formSelector: this.getOption('widgets.form.formContainer'),
				handleDom: {
					onFormSubmit: fox.merge(this.getOption('widgets.form.submit'), {
						targetWidget: '@parent',
						callback: function (a, b, c, e) {
							e.preventDefault();

							this.rwom1('#form').submit();

							return false;
						}.bind(this)
					})
				}
			});

			this.callParent('init', arguments);
		},

		running: function() {
			if (typeof this.prepareTransactionApi === 'undefined') {
				this.prepareTransactionApi = this.rwom1('#prepareTransactionApi');
			}

			try {
				this._prepareJoinOptions();
			} catch (e) {
				this._error('Internal error: cannot get join options');
				fox.log(e.message);
				return;
			}

			this.getTotalContentAmount();

			this.handleEvent('#form', 'form_ready', fox.bind(this.initSelect, this));
			this.handleEvent(this.prepareTransactionApi, 'ready', 'onPrepareTransaction');
			this.handleEvent(this.prepareTransactionApi, ['failure', 'error'], 'onPrepareFailed');
			this.callParent('running', arguments);
		},
		activate: function() {
			this.callParent('activate', arguments);

			this.getTotalContentAmount();
		},

		getTotalContentAmount: function() {
			if (this.getOption('totalContentAllowed')) {
				this.rwom1('#totalApi').send({});
			}
		},

		initSelect: function() {
			this.handleEvent('#form #joinOptions', 'valueChanged', fox.bind(this.changeSelect, this));
			this.requireEmbeddedWidget('form').setValue('joinOptions', this.defaultJoinOption.toString());
		},

		changeSelect: function(w) {
			var selected = fox.dom.selectFirst('.selected');
			var option;
			try {
				option = w.getSelectedOption();
			} catch (e) {
				return;
			}

			if (selected && option) {
				selected.innerHTML = option.text;
			} else {
				selected.innerHTML = 'Select Option';
			}
		},

		onSubmit: function (userData, enhanceData) {
			if (this.__inProgress)
				return false;

			var args = fox.clone(arguments);

			this.userData = userData;
			var transactionParams = fox.merge({
				username: encodeURIComponent(this.userData.login),
				email: encodeURIComponent(this.userData.email)
			}, enhanceData || {});

			if (this.userData.password) {
				transactionParams.password = encodeURIComponent(this.userData.password);
			}

			if (this.getOption('optionsBy') === 'groupId') {
				transactionParams.groupId = this.userData.joinOptions;
			} else {
				transactionParams.optionId = this.userData.joinOptions;
			}

			this.hookWrapper('prepareTransactionParams', transactionParams);
			args[0] = transactionParams;

			this.requireEmbeddedWidget('form').disable();
			this.__inProgress = true;
			return this.prepareTransaction.apply(this, args);
		},

		prepareTransactionParams: function (params) {
			return params;
		},

		prepareTransaction: function(formData, resolve, reject) {
			formData.event = 'user_join';
			var extParams = fox.Navigator.getAll();
			delete extParams[0];

			fox.each(extParams, function(v, k) {
				if (!fox.isSet(formData[k])) {
					formData[k] = encodeURIComponent(v);
				}
			});

			return this.prepareTransactionApi
				.psend(this._prepareUbsOptions(formData)).then(resolve, reject);
		},

		onPrepareTransaction: function(data) {
			this.__inProgress = false;
			this.requireEmbeddedWidget('form').enable();
			$(this.rwom1('#errors').getOption('container')).hide();

			var fields = [];

			fox.each(data.added_fields, function(v, k) {
				fields.push({ key: k, val: v });
			});

			this.rwom1('#billerOptionsForm #optionsList').setCollection(fields);
			this.rwom1('#billerOptionsForm')
				.setTemplateOptions({
					billerUrl: data.submit_url,
					formMethod: data.form_method
				})
				.render();
		},

		onPrepareFailed: function(data) {
			this.__inProgress = false;
			var err = data.answer;
			var messages = [];

			this.requireEmbeddedWidget('form').enable();

			if (!err) {
				console.error('Prepare failed without answer property', data);
				this.dispatchEvent('onPrepareFailed', data);

				return;
			}

			if (fox.isSet(err.type) && (err.type === 6)) {
				fox.each(err.data, function(items) {
					fox.each(items, function(item) {
						messages.push({
							message: item.message
						});
					});
				});
			} else {
				messages.push({
					message: err.reason
				});
			}
			this.rwom1('#errors')
				.setCollection(messages)
				.render();
			$(this.rwom1('#errors').getOption('container')).show();
			this.dispatchEvent('onPrepareFailed', err);
		},

		_prepareJoinOptions: function() {
			var jo = fox.getEnv('siteProps.ubs.joinOptions.options');
			this.hookWrapper('joinOptionsPrepare', jo);

			fox.each(jo, function(o) {
				if (o['default'] === 1) {
					if (this.getOption('optionsBy') === 'groupId') {
						this.defaultJoinOption = o.groupId;
					} else {
						this.defaultJoinOption = o.settings.id;
					}

				}
			}, this);

			if (!this.defaultJoinOption && jo.length) {
				if (this.getOption('optionsBy') === 'groupId') {
					this.defaultJoinOption = jo[fox.getObjectKeys(jo)[0]].groupId;
				} else {
					this.defaultJoinOption = jo[fox.getObjectKeys(jo)[0]].settings.id;
				}
			}

			this.requireEmbeddedWidget('joinOptions')
				.setCollection(jo, false);
			this.dispatchEvent('joinOptionsPrepared');
		},

		joinOptionsPrepare: function (joinOptions) {
			return joinOptions;
		},

		_prepareUbsOptions: function(opts) {
			opts.project = this.rwom1('#prepareTransactionApi').getOption('project');
			opts.site = this.siteId;
			return opts;
		},

		_error: function(text) {
			$(this.rwom1('#errors').getOption('container')).text(text).show();
		},

		_sendBillerForm: function() {
			if (fox.count(this.rwom1('~#optionsList').getCollection())) {
				fox.dom.selectFirst(this.rwom1('#billerOptionsForm').getOption('billerFormSelector')).submit();
			}
		}
	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/join/form.js
// module id = 456
// module chunks = 4